$(function () {
    $('.kitAddToCart').AddToCart({
        loadingControlOptions: {
            loadingText: '',
            loadingTextTag: 'span',
            inheritToggledElementClass: true
        }
    });

    $('.bundle-card__bullets-toggle').click(function () {
        $(this).toggleClass("active");
        $(this).next('.bundle-card__bullets').toggleClass("expanded");
    });

    var mhOptions = {
        byRow: false,
        property: 'height',
        target: null,
        remove: false
    };

    $('.bundle-card .bundle-card__header').matchHeight(mhOptions);

    $('.bundle-card .bci-1').matchHeight(mhOptions);
    $('.bundle-card .bci-2').matchHeight(mhOptions);
    $('.bundle-card .bci-3').matchHeight(mhOptions);
    $('.bundle-card .bci-4').matchHeight(mhOptions);
    $('.bundle-card .bci-5').matchHeight(mhOptions);
    $('.bundle-card .bci-6').matchHeight(mhOptions);
    $('.bundle-card .bci-7').matchHeight(mhOptions);
    $('.bundle-card .bci-8').matchHeight(mhOptions);
    $('.bundle-card .bci-9').matchHeight(mhOptions);

    if (window.MutationObserver) moBundleCard();
});

(function bcToggle() {
    var togglers = document.querySelectorAll(".bundle-card__item-toggle");

    [].forEach.call(togglers, function (toggler) {
        var trigger = toggler.querySelector(".bundle-card__item-toggle-trigger");

        trigger.addEventListener("click", function (e) {
            [].forEach.call(togglers, function (toggler) {
                toggler.classList.toggle("active");
            });
            $.fn.matchHeight._update();
        });
    });
}());

function moBundleCard() {
    const targetNode = document.querySelector('.bundle-card');

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                $.fn.matchHeight._update();
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
}
